import { getToken as getTokenFromPackage } from '@revbox/helpers-fe'
import { CRYPTO_KEY } from './crypto'

export const getToken = advId => {
    return getTokenFromPackage(advId, CRYPTO_KEY)
}
